import client from '../utils/client';
import { shiptimesUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const shiptimeService = {
  shiptimesList,
  addShiptime,
  getShiptime,
  updateShiptime
}

function shiptimesList(pageID, perPage) {
  return client.get(shiptimesUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addShiptime(formDate) {
  return client.post(shiptimesUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getShiptime(shiptimeID) {
  return client.get(shiptimesUrl + '/' + shiptimeID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateShiptime(formDate) {
  return client.post(shiptimesUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}


function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}